// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--vLYXA","phone":"_0d624b9a27--phone--DMNuR","tablet":"_0d624b9a27--tablet--cd_oV","icon":"_0d624b9a27--icon--vbhXr"};